import * as React from 'react';
import cx from 'classnames';
import H5Orientation from '@src/components/h5-orientation';
import { isFoldableDevice } from '@src/utils/common-util';
import styles from './index.less';
import DeviceUtils from '@src/utils/device-utils';
// import deferLoadBetterQuicklink from '@src/utils/defer-load-better-quicklink';

export default class Root extends React.PureComponent {
  mainRef = React.createRef();
  state = {
    initWidth: 0,
    newWidth: 0
  };

  componentDidMount() {
    const mainEl = this.mainRef.current;
    mainEl && (mainEl.scrollTop = 0);
    // deferLoadBetterQuicklink();
    this.setState({
      initWidth: Math.min(document.body.clientWidth, document.body.clientHeight),
      newWidth: document.body.clientWidth
    });
    window.addEventListener('resize', () => {
      this.setState({
        newWidth: document.body.clientWidth
      });
    });
  }

  componentDidUpdate() {
    // deferLoadBetterQuicklink();
  }

  render() {
    const { className, children } = this.props;
    const { initWidth, newWidth } = this.state;
    return (
      <div className={cx(styles.root, className)}>
        {DeviceUtils.isMobile() && !isFoldableDevice() && newWidth > initWidth && <H5Orientation />}
        <div ref={this.mainRef} className={styles.main}>
          {children}
        </div>
      </div>
    );
  }
}
